/**
 * 카테고리 상수 정의
 * Header와 Admin 페이지에서 공통으로 사용
 */

export const CATEGORIES = [
  { name: '♥핫딜♥', value: 'hotdeal', hot: true, description: '특가 상품', prefix: 'HOT' },
  { name: '축하화환', value: 'celebration-wreath', description: '개업, 승진, 당선 등 축하 화환', prefix: 'CEL' },
  { name: '근조화환', value: 'condolence-wreath', description: '조문, 장례식 화환', prefix: 'CON' },
  { name: '쌀화환', value: 'rice-wreath', description: '쌀로 만든 화환', prefix: 'RIC' },
  { name: '서양란', value: 'western-orchid', description: '서양란 화분', prefix: 'WOR' },
  { name: '동양란', value: 'eastern-orchid', description: '동양란 화분', prefix: 'EOR' },
  { name: '꽃바구니', value: 'flower-basket', description: '꽃바구니', prefix: 'FBK' },
  { name: '꽃다발', value: 'flower-bouquet', description: '꽃다발', prefix: 'FBQ' },
  { name: '꽃박스', value: 'flower-box', description: '플라워 박스', prefix: 'FBX' },
  { name: '꽃&케익', value: 'flower-cake', description: '꽃과 케이크 세트', prefix: 'FCK' },
  { name: '비누꽃', value: 'soap-flower', description: '비누로 만든 꽃', prefix: 'SOF' },
  { name: '금전수', value: 'money-tree', description: '금전수 화분', prefix: 'MTR' },
  { name: '스투키', value: 'stucky', description: '스투키 화분', prefix: 'STK' },
  { name: '관엽', value: 'foliage-plant', description: '관엽식물', prefix: 'FOL' },
  { name: '공기정화', value: 'air-purifying', description: '공기정화 식물', prefix: 'AIR' },
  { name: '도자기·분재', value: 'pottery-bonsai', description: '도자기와 분재', prefix: 'POT' },
  { name: '출산·문병', value: 'birth-visit', description: '출산 및 문병 선물', prefix: 'BIR' },
  { name: '해외꽃배달', value: 'overseas-delivery', description: '해외 배송 가능', prefix: 'OVS' },
  { name: '과일바구니', value: 'fruit-basket', description: '과일 바구니', prefix: 'FRT' },
  { name: '행사', value: 'event', description: '각종 행사용', prefix: 'EVT' },
  { name: '결혼/회갑/칠순', value: 'ceremony', description: '결혼식, 회갑, 칠순 등', prefix: 'CER' }
];

// 특별 카테고리 (베스트, 신상품, 추천 상품)
export const SPECIAL_CATEGORIES = [
  { name: '베스트 상품', value: 'best', description: '인기 상품' },
  { name: '신상품', value: 'new', description: '새로 등록된 상품' },
  { name: '추천 상품', value: 'recommended', description: '추천 상품' }
];

// Admin에서 사용할 카테고리 (핫딜 제외, 실제 상품 분류용)
export const ADMIN_CATEGORIES = CATEGORIES.filter(cat => !cat.hot);

// 카테고리 value로 name 찾기
export const getCategoryName = (value) => {
  const category = [...CATEGORIES, ...SPECIAL_CATEGORIES].find(cat => cat.value === value);
  return category ? category.name : value;
};

// 카테고리 name으로 value 찾기
export const getCategoryValue = (name) => {
  const category = [...CATEGORIES, ...SPECIAL_CATEGORIES].find(cat => cat.name === name);
  return category ? category.value : name;
};

// 카테고리 value로 prefix 찾기
export const getCategoryPrefix = (value) => {
  const category = CATEGORIES.find(cat => cat.value === value);
  return category ? category.prefix : 'GEN'; // 기본값: GEN (General)
};

// 상품코드 생성 (카테고리 prefix + 일련번호)
export const generateProductCode = (categoryValue, lastNumber = 0) => {
  const prefix = getCategoryPrefix(categoryValue);
  const nextNumber = lastNumber + 1;
  const paddedNumber = String(nextNumber).padStart(4, '0'); // 4자리 숫자 (0001, 0002, ...)
  return `${prefix}-${paddedNumber}`;
};

